enum ToastType {
  success = 1,
  info,
  caution,
  danger,
  no_icon,
}

export { ToastType };
